var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	5724: {
		fallback: function() { return function() { return __webpack_require__(5723); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: true,
		eager: true,
		layer: undefined,
		shareKey: "react/jsx-runtime",

	},
	983: {
		fallback: function() { return Promise.all([__webpack_require__.e(29), __webpack_require__.e(96), __webpack_require__.e(541), __webpack_require__.e(517), __webpack_require__.e(396)]).then(function() { return function() { return __webpack_require__(8541); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/router",

	},
	8814: {
		fallback: function() { return __webpack_require__.e(865).then(function() { return function() { return __webpack_require__(1246); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	6346: {
		fallback: function() { return Promise.all([__webpack_require__.e(29), __webpack_require__.e(808)]).then(function() { return function() { return __webpack_require__(3808); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/link",

	},
	9136: {
		fallback: function() { return Promise.all([__webpack_require__.e(96), __webpack_require__.e(517), __webpack_require__.e(747)]).then(function() { return function() { return __webpack_require__(1127); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/script",

	},
	4624: {
		fallback: function() { return Promise.all([__webpack_require__.e(915), __webpack_require__.e(517)]).then(function() { return function() { return __webpack_require__(8915); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/image",

	},
	5536: {
		fallback: function() { return __webpack_require__.e(887).then(function() { return function() { return __webpack_require__(1411); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^12 || ^13 || ^14 || ^15",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	9065: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(2155); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	4492: {
		fallback: function() { return __webpack_require__.e(78).then(function() { return function() { return __webpack_require__(3078); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx",

	},
	1449: {
		fallback: function() { return __webpack_require__.e(799).then(function() { return function() { return __webpack_require__(4799); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^5.1.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "styled-jsx/style",

	},
	3134: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(8997); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom/client",

	},
	3517: {
		fallback: function() { return __webpack_require__.e(593).then(function() { return function() { return __webpack_require__(316); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	3049: {
		fallback: function() { return __webpack_require__.e(14).then(function() { return function() { return __webpack_require__(14); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	8833: {
		fallback: function() { return __webpack_require__.e(649).then(function() { return function() { return __webpack_require__(1411); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/dynamic",

	},
	2720: {
		fallback: function() { return __webpack_require__.e(865).then(function() { return function() { return __webpack_require__(1246); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "14.2.16",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "next/head",

	},
	4227: {
		fallback: function() { return __webpack_require__.e(914).then(function() { return function() { return __webpack_require__(7914); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: false,
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [5724,983,8814,6346,9136,4624,5536,9065,4492,1449,5724,9065,3134,3517,2720,8833,3049,4227];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"517": [
		3517
	],
	"527": [
		8814,
		6346,
		9136,
		4624,
		5536,
		9065,
		4492,
		1449
	],
	"636": [
		2720,
		8833,
		3049,
		4227
	],
	"724": [
		5724
	],
	"792": [
		5724,
		9065,
		3134,
		3517
	],
	"814": [
		3049,
		8833
	],
	"983": [
		983
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}